<template>
    <loading-indicator v-if="loading"/>
    <div v-else>
        <template v-if="participants.length">
            <person-box-user v-for="user in participants" :id="user" :key="'chat-read-' + user"/>
        </template>
        <template v-else><em class="text-grey">Die Nachricht wurde noch von keinem gelesen.</em></template>
    </div>
</template>

<script setup lang="ts">
    import {usePortuna} from '@/composables/portuna';
    import axios from 'axios';
    import type {TinyEmitter} from 'tiny-emitter';
    import {errorHandler} from '@/utils/portuna';
    import LoadingIndicator from '../LoadingIndicator.vue';
    import PersonBoxUser from '../PersonBoxUser.vue';
    import {inject, ref} from 'vue';

    const popupEmitter = inject<TinyEmitter>('popup-emitter')!;

    const portuna = usePortuna();

    const props = defineProps<{
        messageId: number;
    }>();

    const loading      = ref(true);
    const participants = ref<number[]>([]);

    axios
    .get('/chat/chat/fetch-message-data/id/' + props.messageId)
    .then(({data: {data}}) =>
    {
        participants.value = data.participants;

        loading.value = false;

        popupEmitter.emit('lazy-load-focus');
    })
    .catch((reason) =>
    {
        errorHandler(reason);

        popupEmitter.emit('close');
    });

    defineExpose(Object.assign({}, portuna, {
        componentName: 'AppChatMessageReadPopup',
    }));
</script>